import {CommonUrlService} from 'core/base/CommonUrlService';
import {get404Exception} from 'core/exceptions/NotFoundException';
import {TAppInitialController} from 'core/redux/types';
import {actionSetBreadCrumbsList} from 'modules/breadcrumbs/slice';
import {getProductList} from 'modules/products/thunks';
import {getActionUrl, setPromoStaticFilter} from 'modules/promo/helpers';
import {selectPromoData} from 'modules/promo/selectors';
import {getPromo, getPromoList} from 'modules/promo/thunks';
import {PAGES} from 'routing/constants';

export const promoListController: TAppInitialController<void> = async ({dispatch}, ctx) => {
    const commonUrlService = new CommonUrlService(
        new URLSearchParams(),
        async (urlSearchParams) => {
            await dispatch(getPromoList(urlSearchParams));
        },
        {
            query: ctx.query,
        }
    );

    await Promise.allSettled([
        dispatch(actionSetBreadCrumbsList([PAGES.HOME_PAGE, PAGES.PROMO_LIST_PAGE])),
        commonUrlService.hydrate(),
    ]);
};

export const promoController: TAppInitialController<void> = async ({dispatch, getState}, ctx) => {
    const promoCode = String(ctx.query.path);
    await dispatch(getPromo(promoCode));

    const action = selectPromoData(getState());
    const {code, id, title} = action;

    if (!id) {
        throw get404Exception();
    }

    setPromoStaticFilter(id);

    const commonUrlService = new CommonUrlService(
        new URLSearchParams(),
        (urlSearchParams) => {
            return dispatch(getProductList(urlSearchParams));
        },
        {
            query: ctx.query,
        }
    );

    await Promise.allSettled([
        commonUrlService.hydrate(),
        dispatch(
            actionSetBreadCrumbsList([
                PAGES.HOME_PAGE,
                PAGES.PROMO_LIST_PAGE,
                {
                    path: getActionUrl(code),
                    title,
                },
            ])
        ),
    ]);
};
